<template>
  <div
    class="py-4 md:p-6 flex items-start border-b border-gray-200 gap-4 transition-300 hover:md:shadow-[0_0_0.875rem_-0.25rem_rgba(0,0,0,0.05),0_2rem_3rem_-0.5rem_rgba(0,0,0,0.05)]"
  >
    <CPreloader
      loading
      width="60px"
      height="60px"
      preloader-class="rounded-full"
    />
    <div class="w-full flex items-start justify-between flex-col gap-1">
      <div class="w-full flex items-start justify-between">
        <CPreloader loading width="130px" height="20px" />
        <CPreloader loading width="75px" height="15px" />
      </div>
      <div>
        <template v-if="isMobile">
          <CPreloader loading width="220px" height="28px" />
        </template>
        <template v-else>
          <CPreloader loading width="320px" height="40px" />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CPreloader from "@/components/CPreloader.vue";
import { useMobile } from "@/composables/useMobile";

const { isMobile } = useMobile("mobile");
</script>
